import Button from "../../general/Button";

export default function MatrixButtonField(content, i) {
    if (!content?.content) {
        return <></>
    }

    return (
        <>
            <Button url={content?.url} text={content?.content} style={content?.style}
                    key={i}
                    rightIcon={(content?.style === 'primary') ? '/assets/icon/chevron-right-white.svg' : '/assets/icon/chevron-right.svg'}
                    className={`mt-[15px] w-fit min-w-[242px] ${content?.style === 'primary' && 'bg-olaf-orange-500 border-olaf-orange-500 hover:text-olaf-orange-500'}`}/>
        </>
    );
}
